export default __webpack_public_path__ + "static/media/danatoken-left-bg.c5d1715f.png";